import { isDevMode, Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { allLocalStorage } from 'src/app/shared/constantes';

/** Payload JWT real: username en `data` (no se valida firma). */
interface MigrationJwtPayload {
    data?: { username?: string };
}

@Injectable()
export class MigrationInterceptor implements HttpInterceptor {
    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        const cfg = environment.domainMigration;
        if (!cfg?.username) {
            return next.handle(request);
        }

        const token = localStorage.getItem(allLocalStorage.accessToken);
        if (!token) {
            return next.handle(request);
        }

        const payload = this.parseJwtPayload(token);
        const tokenUsername = payload?.data?.username;
        if (tokenUsername !== cfg.username) {
            return next.handle(request);
        }

        const newUrl = this.buildMigratedUrl(request.url, cfg);
        if (!newUrl) {
            return next.handle(request);
        }

        if (isDevMode()) {
            console.warn('[Migration] Redirecting request to tecalis.com.');
        }

        return next.handle(request.clone({ url: newUrl }));
    }

    private parseJwtPayload(token: string): MigrationJwtPayload | null {
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(
                atob(base64)
                    .split('')
                    .map((c) => {
                        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                    })
                    .join('')
            );
            return JSON.parse(jsonPayload) as MigrationJwtPayload;
        } catch {
            return null;
        }
    }

    private buildMigratedUrl(
        rawUrl: string,
        cfg: NonNullable<typeof environment.domainMigration>
    ): string | null {
        const parsed = this.tryParseUrl(rawUrl);
        
        if (!parsed || parsed.hostname !== cfg.sourceHostname) {
            return null;
        }
        parsed.hostname = cfg.targetHostname;
        return parsed.toString();
    }

    private tryParseUrl(url: string): URL | null {
        try {
            return new URL(url);
        } catch {
            if (typeof window === 'undefined') {
                return null;
            }
            try {
                return new URL(url, window.location.origin);
            } catch {
                return null;
            }
        }
    }
}
